import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import {
    addPatient,
    deletePatient,
    getPatient,
    searchPatient,
    updatePatient,
} from '../../../redux/actions/Master.action';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';

export default function PatientMaster() {
    const [show, setShow] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [ids, setIds] = useState(null);
    const [mainPage, setMainPage] = useState('1');
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchDefault, setSearchDefault] = useState({
        page: '',
        search: '',
    });

    const [initialValues, setInitialValues] = useState({
        name: '',
    });

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Name is required'),
    });
    const toggle = () => {
        setShow(!show);
    };
    const updateToggle = () => {
        setUpdateModal(!updateModal);
    };
    const deleteToggle = () => {
        setDeleteModal(!deleteModal);
    };

    const dispatch = useDispatch();
    const patientData = useSelector((state) => state.master);

    const [formData, setFormData] = useState({
        name: '',
        gender: '',
        phoneNumber: '',
        mobileNumber: '',
        email: '',
        dateOfBirth: '',
        discount: '',
        city: '',
        pin: '',
    });

    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    };

    const handleAddPatient = (values, { resetForm }) => {
        dispatch(addPatient(values, limits)).then(() => {
            toggle();
            resetForm();
        });
    };

    const handleUpadtePatient = (values) => {
        const payload = {
            name: values.name,
            gender: values.gender,
            phoneNumber: values.phoneNumber,
            mobileNumber: values.mobileNumber,
            email: values.email,
            dateOfBirth: values.dateOfBirth,
            discount: values.discount,
            city: values.city,
            pin: values.pin,
        };

        dispatch(updatePatient(payload, limits, ids)).then(() => {
            setUpdateModal(false);
        });
    };

    const handleDeletePatient = () => {
        dispatch(deletePatient(ids, limits)).then(() => {
            deleteToggle();
            setMainPage(1);
        });
    };

    const handleSearch = (e) => {
        const newSearchQuery = e.target.value;
        setSearchQuery(newSearchQuery);
        const newSearchParams = {
            ...searchDefault,
            search: newSearchQuery || '',
            page: mainPage,
        };
        setSearchDefault(newSearchParams);
        const queryParams = new URLSearchParams(newSearchParams).toString();
        dispatch(searchPatient(queryParams, newSearchParams.page));
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
        const updatedSearchParams = {
            ...searchDefault,
            search: searchQuery,
            page: parseInt(selected.selected) + 1,
        };
        setSearchDefault(updatedSearchParams);
        const queryParams = new URLSearchParams(updatedSearchParams).toString();
        dispatch(searchPatient(queryParams, updatedSearchParams.page));
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        patientData?.getPatient?.data?.totalCount / postPerPage,
    );

    useEffect(() => {
        if (searchQuery) {
            const updatedSearchParams = { ...searchDefault, search: searchQuery, page: mainPage };
            const queryParams = new URLSearchParams(updatedSearchParams).toString();
            dispatch(searchPatient(queryParams, updatedSearchParams.page));
        } else {
            dispatch(getPatient(limits));
        }
    }, [mainPage, rowsPerPage]);

    return (
        <>
            <div className="mt-[100px] d-flex justify-content-end">
                <div className="d-flex items-center gap-3">
                    <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2">
                        <IoSearchOutline />
                        <input
                            type="text"
                            name="search"
                            value={searchQuery}
                            onChange={handleSearch}
                            className="w-full outline-none"
                            placeholder="Search..."
                        />
                    </div>
                    <Button
                        onClick={toggle}
                        className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
                    >
                        <IoMdAdd className="mt-1 gap-1" />
                        Add Patient
                    </Button>
                </div>
            </div>
            <div className="mt-[50px] mb-4">
                <div className='mb-3 flex items-center justify-between mt-5'>
                    <h3 className="fw-bold">Patient Master</h3>
                    <div>
                        Rows per page:
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                        </select>
                    </div>
                </div>
                <TableContainer>
                    <Table variant="striped" colorScheme="blackAlpha">
                        <Thead>
                            <Tr>
                                <Th>Name</Th>
                                {/* <Th>Gender</Th> */}
                                <Th>Phone Number</Th>
                                {/* <Th>Mobile Number</Th> */}
                                {/* <Th>Email Id</Th> */}
                                {/* <Th>Birthdate</Th> */}
                                {/* <Th>Discount</Th> */}
                                <Th>City</Th>
                                {/* <Th>Pin</Th> */}
                                <Th className="text-end">Action</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {patientData?.getPatient?.data?.data?.length > 0 ? (
                                patientData?.getPatient?.data?.data?.map((res) => {
                                    return (
                                        <Tr key={res._id}>
                                            <Td>{res.name}</Td>
                                            {/* <Td>{res.gender}</Td> */}
                                            <Td>{res.phoneNumber}</Td>
                                            {/* <Td>{res.mobileNumber}</Td> */}
                                            {/* <Td>{res.email}</Td> */}
                                            {/* <Td>{res.dateOfBirth}</Td> */}
                                            {/* <Td>{res.discount} %</Td> */}
                                            <Td>{res.city}</Td>
                                            {/* <Td>{res.pin}</Td> */}
                                            <Td style={{ minWidth: '200px' }}>
                                                <div className="d-flex gap-3 justify-end">
                                                    <FaEdit
                                                        onClick={() => {
                                                            updateToggle();
                                                            setFormData(res);
                                                            setIds(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-success"
                                                        title="update"
                                                    />
                                                    <MdDelete
                                                        onClick={() => {
                                                            deleteToggle();
                                                            setIds(res._id);
                                                        }}
                                                        className="cursor-pointer border-green-color fs-5 text-danger"
                                                        title="delete"
                                                    />
                                                </div>
                                            </Td>
                                        </Tr>
                                    );
                                })
                            ) : (
                                <>
                                    <Tr>
                                        <Td colSpan={10} textAlign="center">
                                            Batch Not Found
                                        </Td>
                                    </Tr>
                                </>
                            )}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>

            <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={ChangeMainPage}
                pageRangeDisplayed={5}
                pageCount={PageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                className="pagination"
            />

            {/* add patient */}

            <Modal show={show} onHide={toggle} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Add Patient</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleAddPatient}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('name', e.target.value)
                                                }
                                                value={values.name}
                                                placeholder="Enter Name"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="name"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gender</Form.Label>
                                            <Form.Select value={values.gender} className="shadow-none focus:!border-theme-dark" onChange={(e) => setFieldValue('gender', e.target.value)} aria-label="Default select example">
                                                <option>Select Gender</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Transender">Transender</option>
                                            </Form.Select>
                                            <ErrorMessage
                                                name="gender"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="phoneNumber"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('phoneNumber', e.target.value)
                                                }
                                                value={values.phoneNumber}
                                                placeholder="Enter Phone Number"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="phoneNumber"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Mobile Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="mobileNumber"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('mobileNumber', e.target.value)
                                                }
                                                value={values.mobileNumber}
                                                placeholder="Enter Mobile Number"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="mobileNumber"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email Id</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('email', e.target.value)
                                                }
                                                value={values.email}
                                                placeholder="Enter Email Id"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="email"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Date Of Birtdate</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="dateOfBirth"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('dateOfBirth', e.target.value)
                                                }
                                                value={values.dateOfBirth}
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="dateOfBirth"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Discount</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="discount"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('discount', e.target.value)
                                                }
                                                value={values.discount}
                                                placeholder="Enter Discount"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="discount"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>City</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="city"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('city', e.target.value)
                                                }
                                                value={values.city}
                                                placeholder="Enter City"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="city"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Pin</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="pin"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('pin', e.target.value)
                                                }
                                                value={values.pin}
                                                placeholder="Enter Pin"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="pin"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* update patient */}

            <Modal show={updateModal} onHide={updateToggle} size='lg'>
                <Modal.Header closeButton>
                    <Modal.Title>Update Diagnosis</Modal.Title>
                </Modal.Header>

                <Formik
                    enableReinitialize={true}
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpadtePatient}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('name', e.target.value)
                                                }
                                                value={values.name}
                                                placeholder="Enter Name"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="name"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Gender</Form.Label>
                                            <Form.Select value={values.gender} className="shadow-none focus:!border-theme-dark" onChange={(e) => setFieldValue('gender', e.target.value)} aria-label="Default select example">
                                                <option>Select Gender</option>
                                                <option value="Male">Male</option>
                                                <option value="Female">Female</option>
                                                <option value="Transender">Transender</option>
                                            </Form.Select>
                                            <ErrorMessage
                                                name="gender"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="phoneNumber"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('phoneNumber', e.target.value)
                                                }
                                                value={values.phoneNumber}
                                                placeholder="Enter Phone Number"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="phoneNumber"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Mobile Number</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="mobileNumber"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('mobileNumber', e.target.value)
                                                }
                                                value={values.mobileNumber}
                                                placeholder="Enter Mobile Number"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="mobileNumber"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email Id</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('email', e.target.value)
                                                }
                                                value={values.email}
                                                placeholder="Enter Email Id"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="email"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Date Of Birtdate</Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="dateOfBirth"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('dateOfBirth', e.target.value)
                                                }
                                                value={values.dateOfBirth}
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="dateOfBirth"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Discount</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="discount"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('discount', e.target.value)
                                                }
                                                value={values.discount}
                                                placeholder="Enter Discount"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="discount"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>City</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="city"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('city', e.target.value)
                                                }
                                                value={values.city}
                                                placeholder="Enter City"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="city"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-4">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Pin</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="pin"
                                                as={Form.Control}
                                                onChange={(e) =>
                                                    setFieldValue('pin', e.target.value)
                                                }
                                                value={values.pin}
                                                placeholder="Enter Pin"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="pin"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button type="submit" className="!bg-theme-dark border-0 px-4">
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete patient */}

            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className="p-5">
                    <div>
                        <PiWarningCircleBold className="text-7xl w-100 text-danger" />
                    </div>
                    <div className="text-center mt-4">
                        <h3>Are You Sure ?</h3>
                        <p className="text-md">
                            Do you really want to delete these records?
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDeletePatient}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
